module.exports = __webpack_public_path__ + "static/media/insta-10.7446b242.png";